<template>
    <div>
        <div class="box760">
            <div class="steps flex justify-content align-items">
                <div class="item active justify-content align-items flex column">
                    <p class="circular"><i></i></p>
                    <p class="text">填写资料</p>
                </div>
                <div class="line line-ff9203"></div>
                <div class="item underway justify-content align-items flex column">
                    <p class="circular"><i></i></p>
                    <p class="text">达人培训</p>
                </div>
                <div class="line"></div>
                <div class="item justify-content align-items flex column">
                    <p class="circular"><i></i></p>
                    <p class="text">认证成功</p>
                </div>
            </div>
        </div>
        <div class="box760 white-bg shadow fromBox border">
            <h3 class="attestation-title">请选择到现场参与培训的时间</h3>
            <div class="attestation-content">
                <el-form ref="form" :model="form" label-width="200px" label-position="top">
                    <el-form-item label="培训时间">
                        <el-date-picker type="date" placeholder="选择日期" v-model="form.date1" style="width: 100%;"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="培训地点">
                        广州市天河区高德置地写字楼G座 <a href="">查看地图</a>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" style="width: 100%;">确认预约</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>
<script>
export default {
  name: 'Offline',
  data () {
    return {
      form: {
        name: '',
        abbreviation: '',
        person: '',
        address: '',
        tel: '',
        mobile: '',
        business: '',
        code: '',
        dialogImageUrl: '',
        dialogVisible: false
      }
    }
  }
}
</script>
<style scoped></style>
